const PackageTypes = {
  COMPACT: 'Compact',
  COMPLETE: 'Complete',
  NOVELLA: 'Novella',
  CUSTOM: 'Bespoke/Custom',
  SWIFT: 'Swift',
  YEARBOOK: 'Yearbook',
  TRAVEL_BOOK: 'Travel book',
};

module.exports = PackageTypes;
